export const realChainIds = {
  localhost: 31337,
  eth_mainnet: 1,
  bsc_mainnet: 56,
  polygon_mainnet: 137,
  avax_mainnet: 43114,
  ftm_mainnet: 250,
  arbitrum_mainnet: 42161,
  celo_mainnet: 42220,
  metis_mainnet: 1088,
  cube_mainnet: 1818,
  okex_mainnet: 66,
  cmp_mainnet: 256256,
  pulse_mainnet: 369,
  base_mainnet: 8453,
  bitlayer_mainnet: 200901,
  xend_mainnet: 42420,

  rinkeby: 4,
  ropsten: 3,
  goerli: 5,
  bsc_testnet: 97,
  polygon_testnet: 80001,
  avax_testnet: 43113,
  ftm_testnet: 4002,
  arbitrum_testnet: 421611,
  celo_alfajores_testnet: 44787,
  metis_testnet: 588,
  cube_testnet: 1819,
  okex_testnet: 65,
  cmp_testnet: 512512,
  pulse_testnet: 943,
  xend_testnet: 42421,
  arbitrum_sepolia: 421614,
  base_sepolia: 84532,
  polygon_amoy: 80002,
  eth_sepolia: 11155111,
  bitlayer_testnet: 200810,
  solana_mainnet: "sol.mainnet",
  solana_devnet: "sol.devnet",
};

export type ChainTag = keyof typeof realChainIds;

export type RpcFunction = (chainTag: ChainTag) => string;

export const chainTags: Record<number | string, ChainTag> = {};
for (const tag in realChainIds) {
  const id = realChainIds[tag as ChainTag];
  // if (typeof id === "number") {
  //   chainTags[id] = tag as ChainTag;
  // }
  chainTags[id] = tag as ChainTag;
}

export const scanners: Record<ChainTag, string> = {
  localhost: "/",
  eth_mainnet: "https://etherscan.io/",
  bsc_mainnet: "https://bscscan.com/",
  polygon_mainnet: "https://polygonscan.com/",
  avax_mainnet: "https://snowtrace.io/",
  ftm_mainnet: "https://ftmscan.com/",
  arbitrum_mainnet: "https://arbiscan.io/",
  celo_mainnet: "https://celoscan.io/",
  metis_mainnet: "https://andromeda-explorer.metis.io/",
  cube_mainnet: "https://www.cubescan.network/",
  okex_mainnet: "https://www.oklink.com/en/okc/",
  cmp_mainnet: "https://mainnet.scan.caduceus.foundation/",
  pulse_mainnet: "https://scan.mypinata.cloud/ipfs/bafybeih3olry3is4e4lzm7rus5l3h6zrphcal5a7ayfkhzm5oivjro2cp4/#/",
  base_mainnet: "https://basescan.org/",
  bitlayer_mainnet: "https://www.btrscan.com/",
  xend_mainnet: "https://scan.assetchain.org/",

  rinkeby: "https://rinkeby.etherscan.io/",
  ropsten: "https://ropsten.etherscan.io/",
  goerli: "https://goerli.etherscan.io/",
  bsc_testnet: "https://testnet.bscscan.com/",
  polygon_testnet: "https://mumbai.polygonscan.com/",
  avax_testnet: "https://testnet.snowtrace.io/",
  ftm_testnet: "https://testnet.ftmscan.com/",
  arbitrum_testnet: "https://testnet.arbiscan.io/",
  celo_alfajores_testnet: "https://alfajores.celoscan.io/",
  metis_testnet: "https://stardust-explorer.metis.io/",
  cube_testnet: "https://testnet.cubescan.network/",
  okex_testnet: "https://www.oklink.com/en/okc-test/",
  cmp_testnet: "https://galaxy.scan.caduceus.foundation/",
  pulse_testnet: "https://scan.v4.testnet.pulsechain.com",
  xend_testnet: "https://scan-testnet.assetchain.org/",
  arbitrum_sepolia: "https://sepolia.arbiscan.io/",
  base_sepolia: "https://sepolia.basescan.org/",
  eth_sepolia: "https://ethereum-sepolia-rpc.publicnode.com/",
  polygon_amoy: "https://polygon-amoy-bor-rpc.publicnode.com/",
  bitlayer_testnet: "https://testnet.btrscan.com/",
  solana_mainnet: "https://explorer.solana.com/",
  solana_devnet: "https://explorer.solana.com/",
};

export const realNames: Record<ChainTag, string> = {
  localhost: "Localhost",

  eth_mainnet: "Ethereum",
  bsc_mainnet: "BNB Chain",
  polygon_mainnet: "Polygon",
  avax_mainnet: "Avalanche",
  ftm_mainnet: "Fantom",
  arbitrum_mainnet: "Arbitrum",
  celo_mainnet: "Celo",
  metis_mainnet: "Metis",
  cube_mainnet: "Cube Chain",
  okex_mainnet: "OKExChain",
  cmp_mainnet: "CMP",
  pulse_mainnet: "PulseChain",
  base_mainnet: "Base",
  bitlayer_mainnet: "Bitlayer",
  xend_mainnet: "Asset Chain",

  rinkeby: "Rinkeby",
  ropsten: "Ropsten",
  goerli: "Goerli",
  bsc_testnet: "BNB Chain",
  polygon_testnet: "Polygon",
  avax_testnet: "Avalanche",
  ftm_testnet: "Fantom",
  arbitrum_testnet: "Arbitrum",
  celo_alfajores_testnet: "Celo",
  metis_testnet: "Metis Stardust",
  cube_testnet: "Cube",
  okex_testnet: "OKExChain",
  cmp_testnet: "CMP",
  pulse_testnet: "PulseChain",
  xend_testnet: "Asset Chain",
  arbitrum_sepolia: "Arbitrum",
  base_sepolia: "Base",
  eth_sepolia: "Sepolia",
  polygon_amoy: "Amoy",
  bitlayer_testnet: "Bitlayer",
  solana_mainnet: "Solana",
  solana_devnet: "Solana",
};

export const realSymbols: Record<ChainTag, string> = {
  localhost: "LOC",

  eth_mainnet: "ETH",
  bsc_mainnet: "BNB",
  polygon_mainnet: "MATIC",
  avax_mainnet: "AVAX",
  ftm_mainnet: "FTM",
  arbitrum_mainnet: "ETH",
  celo_mainnet: "CELO",
  metis_mainnet: "METIS",
  cube_mainnet: "CUBE",
  okex_mainnet: "OKT",
  cmp_mainnet: "CMP",
  pulse_mainnet: "PLS",
  base_mainnet: "ETH",
  bitlayer_mainnet: "BTC",
  xend_mainnet: "RWA",

  rinkeby: "ETH",
  ropsten: "ETH",
  goerli: "ETH",
  bsc_testnet: "BNB",
  polygon_testnet: "MATIC",
  avax_testnet: "AVAX",
  ftm_testnet: "FTM",
  arbitrum_testnet: "ETH",
  celo_alfajores_testnet: "CELO",
  metis_testnet: "METIS",
  cube_testnet: "CUBE",
  okex_testnet: "OKT",
  cmp_testnet: "CMP",
  pulse_testnet: "PLS",
  xend_testnet: "RWA",
  arbitrum_sepolia: "ETH",
  base_sepolia: "ETH",
  eth_sepolia: "ETH",
  polygon_amoy: "MATIC",
  bitlayer_testnet: "BTC",
  solana_mainnet: "SOL",
  solana_devnet: "SOL",
};

export const extraRpcs: Record<ChainTag, string[]> = {
  localhost: ["http://127.0.0.1:8545/"],

  eth_mainnet: [
    "https://ethereum.publicnode.com",
    "https://1rpc.io/eth",
    "https://ethereum.therpc.io",
    "https://eth.llamarpc.com",
  ],
  bsc_mainnet: [
    "https://bsc-rpc.publicnode.com",
    "https://bsc-dataseed1.binance.org/",
    "https://bsc-dataseed2.binance.org/",
    "https://bsc-dataseed3.binance.org/",
    "https://bsc-dataseed4.binance.org/",
    "https://bsc-dataseed1.defibit.io/",
    "https://bsc-dataseed2.defibit.io/",
    "https://bsc-dataseed3.defibit.io/",
    "https://bsc-dataseed4.defibit.io/",
    "https://bsc-dataseed1.ninicoin.io/",
    "https://bsc-dataseed2.ninicoin.io/",
    "https://bsc-dataseed3.ninicoin.io/",
    "https://bsc-dataseed4.ninicoin.io/",
    "https://rpc.ankr.com/bsc",
  ],
  polygon_mainnet: [
    "https://polygon-bor-rpc.publicnode.com",
    "https://polygon-bor-rpc.publicnode.com",
    "https://polygon.therpc.io",
    "https://rpc.ankr.com/polygon",
  ],
  avax_mainnet: ["https://api.avax.network/ext/bc/C/rpc", "https://rpc.ankr.com/avalanche"],
  ftm_mainnet: ["https://rpc.ftm.tools", "https://rpc.ankr.com/fantom"],
  arbitrum_mainnet: [
    `https://arbitrum-one-rpc.publicnode.com`,
    "https://arbitrum-mainnet.publicnode.com",
    "https://arbitrum.public-rpc.com",
    "https://arb1.arbitrum.io/rpc",
    "https://api.zan.top/arb-one",
    // "https://arbitrum.llamarpc.com",
    "https://endpoints.omniatech.io/v1/arbitrum/one/public",
    "https://1rpc.io/arb",
    "https://arb1.arbitrum.io/rpc",
  ],
  celo_mainnet: ["https://rpc.ankr.com/celo"],
  metis_mainnet: ["https://andromeda.metis.io/?owner=1088"],
  cube_mainnet: ["https://http-mainnet.cube.network"],
  okex_mainnet: ["https://exchainrpc.okex.org/"],
  cmp_mainnet: ["https://mainnet.block.caduceus.foundation"],
  pulse_mainnet: ["https://pulsechain.publicnode.com"],
  base_mainnet: [
    "https://base-rpc.publicnode.com",
    "https://mainnet.base.org",
    "https://base.llamarpc.com",
    "https://base.api.onfinality.io/public",
  ],
  bitlayer_mainnet: ["https://rpc.bitlayer.org", "https://rpc-bitlayer.rockx.com"],
  xend_mainnet: ["https://mainnet-rpc.assetchain.org"],

  rinkeby: ["https://rinkeby.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161"],
  ropsten: ["https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161"],
  goerli: ["https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161"],
  bsc_testnet: [
    // 'https://bsc-testnet-rpc.publicnode.com',
    // 'https://bsctestapi.terminet.io/rpc',
    "https://data-seed-prebsc-1-s1.binance.org:8545/",
    "https://data-seed-prebsc-2-s1.binance.org:8545/",
    "http://data-seed-prebsc-1-s2.binance.org:8545/",
    "http://data-seed-prebsc-2-s2.binance.org:8545/",
    "https://data-seed-prebsc-1-s3.binance.org:8545/",
    "https://data-seed-prebsc-2-s3.binance.org:8545/",
  ],
  polygon_testnet: ["https://rpc-mumbai.maticvigil.com"],
  avax_testnet: ["https://api.avax-test.network/ext/bc/C/rpc"],
  ftm_testnet: ["https://rpc.testnet.fantom.network/"],
  arbitrum_testnet: ["https://rinkeby.arbitrum.io/rpc"],

  celo_alfajores_testnet: ["https://alfajores-forno.celo-testnet.org"],
  metis_testnet: ["https://stardust.metis.io/?owner=588"],
  cube_testnet: ["https://http-testnet.cube.network"],
  okex_testnet: ["https://exchaintestrpc.okex.org"],
  cmp_testnet: ["https://galaxy.block.caduceus.foundation	"],
  pulse_testnet: ["https://rpc.v4.testnet.pulsechain.com"],
  xend_testnet: ["https://enugu-rpc.assetchain.org/"],
  arbitrum_sepolia: [
    "https://arb-sepolia.g.alchemy.com/v2/3k2TcfwiK3jj9BVIoq0_dhZhzS1O7f3B",
    "https://arbitrum-sepolia-testnet.rpc.grove.city/v1/01fdb492",
    "https://endpoints.omniatech.io/v1/arbitrum/sepolia/public",
  ],
  base_sepolia: ["https://base-sepolia-rpc.publicnode.com"],
  eth_sepolia: ["https://ethereum-sepolia-rpc.publicnode.com"],
  polygon_amoy: ["https://polygon-amoy-bor-rpc.publicnode.com"],
  bitlayer_testnet: ["https://testnet-rpc.bitlayer.org"],
  solana_mainnet: ["https://api.mainnet-beta.solana.com"],
  solana_devnet: ["https://api.devnet.solana.com"],
};

export const universalRpc = (): RpcFunction => {
  return (chainTag: ChainTag) => {
    const a: Record<ChainTag, string> = {
      avax_mainnet: extraRpcs.avax_mainnet[0],
      bsc_mainnet: extraRpcs.bsc_mainnet[0],
      arbitrum_mainnet: extraRpcs.arbitrum_mainnet[0],
      eth_mainnet: extraRpcs.eth_mainnet[0],
      ftm_mainnet: extraRpcs.ftm_mainnet[0],
      polygon_mainnet: extraRpcs.polygon_mainnet[0],
      celo_mainnet: extraRpcs.celo_mainnet[0],
      pulse_mainnet: extraRpcs.pulse_mainnet[0],
      base_mainnet: extraRpcs.base_mainnet[0],
      bitlayer_mainnet: extraRpcs.bitlayer_mainnet[0],

      avax_testnet: extraRpcs.avax_testnet[0],
      polygon_testnet: extraRpcs.polygon_testnet[0],
      ftm_testnet: extraRpcs.ftm_testnet[0],
      rinkeby: extraRpcs.rinkeby[0],
      ropsten: extraRpcs.ropsten[0],
      goerli: extraRpcs.goerli[0],
      pulse_testnet: extraRpcs.pulse_testnet[0],

      arbitrum_testnet: extraRpcs.arbitrum_testnet[0],
      bsc_testnet: extraRpcs.bsc_testnet[0],
      localhost: extraRpcs.localhost[0],

      metis_mainnet: extraRpcs.metis_mainnet[0],
      cube_mainnet: extraRpcs.cube_mainnet[0],
      okex_mainnet: extraRpcs.okex_mainnet[0],
      cmp_mainnet: extraRpcs.cmp_mainnet[0],

      celo_alfajores_testnet: extraRpcs.celo_alfajores_testnet[0],
      metis_testnet: extraRpcs.metis_testnet[0],
      cube_testnet: extraRpcs.cube_testnet[0],
      okex_testnet: extraRpcs.okex_testnet[0],
      cmp_testnet: extraRpcs.cmp_testnet[0],
      arbitrum_sepolia: extraRpcs.arbitrum_sepolia[0],
      xend_testnet: extraRpcs.xend_testnet[0],
      base_sepolia: extraRpcs.base_sepolia[0],
      eth_sepolia: extraRpcs.eth_sepolia[0],
      polygon_amoy: extraRpcs.polygon_amoy[0],
      bitlayer_testnet: extraRpcs.bitlayer_testnet[0],
      xend_mainnet: extraRpcs.xend_mainnet[0],
      solana_mainnet: extraRpcs.solana_mainnet[0],
      solana_devnet: extraRpcs.solana_devnet[0],
    };
    return a[chainTag];
  };
};
